import React from "react";
import { EuiFlexItem } from "@elastic/eui";
import { useSelector } from "react-redux";
import TripDetailsSection from "../TripDetailsSection";
import { getUserRoles } from "../../../../auth/slice";
import { userRoles } from "../../../../../constants/userRoles";

export default function ShipmentAmountDetails({ label, options, amount, onChange, isEditable }) {
    const getCurrentUserRoles = useSelector(getUserRoles());
    const shipmentAmountDetailsIsEditable =
        getCurrentUserRoles.some((role) => role === userRoles.ACCOUNT_MANAGER) || isEditable;

    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                selectedValue={amount}
                options={options}
                onSave={onChange}
                isEditable={shipmentAmountDetailsIsEditable}
            />
        </EuiFlexItem>
    );
}
